import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Text, Link as ChakraLink } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { CheckboxesSection } from "./components/CheckboxesSection";
import { RadioButtonsSection } from "./components/RadioButtonsSection";
import { RegisterForm } from "./components/RegisterForm";
import { AuthViewWrapper } from "../../hocs/AuthViewWrapper";
import { authorization } from "@lubbezposrednio-frontend/core";

interface RegisterViewProps {}

export const RegisterView: React.FC<RegisterViewProps> = observer(({}) => {
  useEffect(() => {
    document.title = "Rejestracja";
    authorization.clearInputData();
  }, []);

  return (
    <AuthViewWrapper
      authorization={authorization}
      buttonText="Zarejestruj się"
      title="Załóż konto"
      subtitle="Konto pozwala tworzyć i prowadzić własne głosowania. Do udziału w głosowaniu nie jest potrzebne."
      cyberspaceOAuth
      submitAction={authorization.register}
      bottomElement={
        <Text fontSize="14px" color="gray.500" textAlign="center">
          Masz już konto?{" "}
          <ChakraLink as={Link} to="/logowanie" color="accent" fontWeight="700" _hover={{ textDecoration: "underline" }}>
            Zaloguj się
          </ChakraLink>
        </Text>
      }
    >
      <RegisterForm authorization={authorization} />
      <RadioButtonsSection authorization={authorization} />
      <CheckboxesSection authorization={authorization} />
    </AuthViewWrapper>
  );
});
